import { environment } from "./../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { AuthService } from "../auth.service";
import { User } from "../user";

@Component({
  selector: "app-quiz",
  templateUrl: "./quiz.component.html",
  styleUrls: ["./quiz.component.css"],
})
export class QuizComponent {
  currentUser: User = new User();
  mat_name;
  mat_id;
  mat_price;
  questions = [];
  answredQ = [];
  currentIndex: number;
  notAttempted: any;
  correct: any;
  currentQuestionSet: any;
  start = false;
  gameover = false;
  buttonname = "Play";
  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private _location: Location,
    private authServie: AuthService,
    private router: Router
  ) {
    this.route.queryParams.subscribe((params) => {
      this.mat_name = params["mat_name"];
      this.mat_id = params["quiz"];
      this.mat_price = params ["mat_price"];
      this.http
        .get(
          `${environment.apiUrl}/quizz/get-quizzes-by-mat-id/${params["quiz"]}`
        )
        .subscribe((data) => {
          this.questions = data["data"][0]["questions"];
        });
    });
    this.authServie.currentUser.subscribe((data) => {
      console.log(data);
      this.currentUser = data["data"];
    });
  }

  next() {
    this.currentIndex = this.currentIndex + 1;
    this.currentQuestionSet = this.questions[this.currentIndex];
  }

  backq() {
    this.currentIndex = this.currentIndex - 1;
    this.currentQuestionSet = this.questions[this.currentIndex];
  }

  submit() {
    this.buttonname = "Replay";
    if (this.currentIndex + 1 == this.questions.length) {
      this.gameover = true;
      this.start = false;
      this.correct = 0;
      this.notAttempted = 0;
      this.questions.map((x) => {
        if (x.selected != 0) {
          if (x.selected == x.true_answer) this.correct = this.correct + 1;
        } else {
          this.notAttempted = this.notAttempted + 1;
        }
        x.selected = 0;
      });
    }
    this.http
      .post(`${environment.apiUrl}/users-marks`, {
        material_name: this.mat_name,
        user_email: this.currentUser["email"],
        name: this.currentUser["name"],
        mark: this.correct + "/" + this.questions.length,
      })
      .subscribe();
  }

  startQuiz() {
    this.gameover = false;
    this.currentIndex = 0;
    this.currentQuestionSet = this.questions[this.currentIndex];
    this.start = true;
  }

  handleChange($event) {
    console.log($event.target.value);
  }

  back() {
    this._location.back();
  }

  goToTrueAnswers() {
    this.router.navigate(["/true-answers"], {
      queryParams: {
        mat: this.mat_id,
      },
    });
  }

  getCert() {
    window.open(
      "https://sinnara-app.com/certificate583CeYjmYXm5bFNT",
      "_blank"
    );
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem("currentUser");
    return this.http
      .post(`${environment.apiUrl}/auth/logout`, {})
      .subscribe(
        (data) => (window.location.href = "https://sinnara-app.com/log-in.html")
      );
  }
}
